export default {
      id: "oc-res-host_image-usage",
      viewBox: "0 0 1136 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-host_image",
      toString: function () {
        return this.url;
      }
    }